import React, { useEffect, useState } from "react";
import {
  ILibrary,
  fetchLibraryById,
} from "../screens/library/LibraryController";
import { useLocation, useNavigate } from "react-router-dom";
import BackButton from "./common/BackButton";
import UseTranslationHook from "../hooks/UseTranslationHook";
import LibraryOpenType from "../screens/library/LibraryOpenType";
import CardListPageSkeleton from "./common/skeletons/CardListPageSkeleton";
import { userRoute } from "../routes/RouteUser";
import { LIBRARY_VIEW_TYPE, USER_ROLE } from "../utils/AppEnumerations";
import { localStorageUtils } from "../utils/LocalStorageUtil";
import { routeTrainer } from "../routes/RouteTrainer";
import { decryptData } from "../utils/AppFunctions";

const FolderDetail = () => {
  const userRole = Number(localStorageUtils.getRole());
  const navigate = useNavigate();
  const { t } = UseTranslationHook();
  const [libraryList, setLibraryList] = useState<ILibrary[]>([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const paramsId = searchParams.get("id");
  const decryptParams = decryptData(paramsId ? paramsId.toString() : "");
  const [parmasId, hasSubscripb] = decryptParams.split("|");
  const objectId = location?.state?.id ? location?.state?.id : parmasId;
  const sp = location?.state?.sp || hasSubscripb ? true : false;
  const heading = location?.state?.heading;
  const [navigationPath, setNavigationPath] = useState<
    { object_id: number; title: string }[]
  >([{ object_id: objectId, title: heading }]);

  useEffect(() => {
    fetchLibraryById(
      setLibraryList,
      setLoading,
      true,
      sp,
      LIBRARY_VIEW_TYPE.Other,
      objectId
    );
  }, []);

  const breadCrumb = ({
    navigationPath,
    onNavigate,
  }: {
    navigationPath: { object_id: number; title: string }[];
    onNavigate: (index: number) => void;
  }) => {
    return (
      <div className="my-3 flex items-center rounded-lg  overflow-hidden">
        <div
          className={`flex text-nowrap items-center text-sm comman-black-text ${
            navigationPath.length === 0 ? "comman-border" : "border-library"
          } px-2 rounded-lg  ${
            navigationPath.length > 0 ? "cursor-pointer" : ""
          }`}
          onClick={() =>
            navigate(
              userRole === USER_ROLE.Trainer
                ? routeTrainer.library
                : userRoute.library
            )
          }
        >
          {t("home")}
        </div>
        <div className="overflow-auto flex">
          {navigationPath.map((folder, index) => (
            <div
              key={folder.object_id}
              className="flex items-center rounded-lg"
            >
              <span className="mx-2 text-gray-300">&gt;</span>
              {folder.title && (
                <div
                  className={`flex text-nowrap items-center px-2 rounded-lg comman-black-text ${
                    navigationPath.length !== index + 1 && "cursor-pointer"
                  } !text-sm ${
                    navigationPath.length === index + 1
                      ? "bread-crumb-border"
                      : "border-library"
                  }`}
                  onClick={() => onNavigate(index + 1)}
                >
                  {folder.title}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  };
  const handleNavigate = async (index: number) => {
    if (index >= 0 && index < navigationPath.length) {
      let objectID: number;
      if (index === 0) {
        objectID = 1;
      } else {
        objectID = navigationPath[index - 1].object_id;
      }
      fetchLibraryById(
        setLibraryList,
        setLoading,
        true,
        sp,
        LIBRARY_VIEW_TYPE.Other,
        objectID
      );
      setNavigationPath((prevPath) => prevPath.slice(0, index));
    }
  };
  const handleFolderClick = (id: number, objectName: string) => {
    return () => {
      fetchLibraryById(
        setLibraryList,
        setLoading,
        true,
        sp,
        LIBRARY_VIEW_TYPE.Other,
        id
      );
      setNavigationPath((prevPath) => [
        ...prevPath,
        { object_id: id, title: objectName },
      ]);
    };
  };
  return (
    <div className="comman-padding overflow-hidden flex flex-col h-svh md:h-[calc(100vh-70px)]">
      <div className=" flex justify-center items-center">
        <BackButton />
        <h1 className="w-full ml-4 text-left comman-black-big">
          {t("library")}
        </h1>
      </div>
      {breadCrumb({ navigationPath, onNavigate: handleNavigate })}
      {loading ? (
        <CardListPageSkeleton />
      ) : (
        <div className="flex-1 overflow-auto">
          <div className="grid grid-cols-2 sm:grid-cols-2  lg:grid-cols-4 xl:grid-cols-5 gap-3 w-full">
            {libraryList && libraryList.length > 0 ? (
              libraryList.map((item, index) => (
                <>
                  <div key={index}>
                    <LibraryOpenType
                      handleFolderClick={handleFolderClick(
                        item.object_id,
                        item.title
                      )}
                      libraryList={libraryList}
                      setLibraryList={setLibraryList}
                      itemArray={{
                        ...item,
                        ...(hasSubscripb === "hst" && { has_subscribed: "1" }),
                      }}
                      childClass="w-full"
                      index={index}
                      videoControls={[
                        "progress",
                        "current-time",
                        "fullscreen",
                        "play-large",
                      ]}
                    />
                  </div>
                </>
              ))
            ) : (
              <p>{t("no_data")}</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default FolderDetail;
